import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const RolesCtx = createContext({ roles: [], roleMap: {}, reload: () => {} });

export function RolesProvider({ children }) {
  const { user } = useAuth();
  const [roles, setRoles] = useState([]);
  const reload = useCallback(() => api.get("/roles").then((r) => setRoles(r.data)), []);
  useEffect(() => { if (user) reload(); }, [user, reload]);
  const roleMap = Object.fromEntries(roles.map((r) => [r.key, r]));
  return <RolesCtx.Provider value={{ roles, roleMap, reload }}>{children}</RolesCtx.Provider>;
}

export const useRoles = () => useContext(RolesCtx);
